import styled from '@emotion/styled';
import * as SC from '../../../../SC/App.sc';

export const Container = styled(SC.FlexRow)`
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
`;
